import script from "./LinkItem.vue?vue&type=script&setup=true&lang=js"
export * from "./LinkItem.vue?vue&type=script&setup=true&lang=js"

import "./LinkItem.vue?vue&type=style&index=0&id=57bcd590&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-57bcd590"]])

export default __exports__